import React, { } from 'react';
import EventBlock from '../../components/EventBlock'
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useLocaladminContext } from '../../../common/Context';


export default function LocaladminEventsCalendar(props) {

    const local = useLocaladminContext();

    // const regionalnoeOtdelenie = useSelector(getRregionalnoeOtdelenieFromRoles(["АдминистраторОтделения", "АдминистраторМероприятийРО"], true));
    const auth = useAuth()
    // const [regionalnoeOtdelenie, setRegionalnoeOtdelenie] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/ro/list-by-admin', ({data})=>{
    //         setRegionalnoeOtdelenie(data);
    //     }, errorCatch)
    // }, [])

    return (
        <PageLayout>
            {local && <EventBlock {...props} source={"/api/meropriyatiya/list/reg"}
                base="local-admin"
                sourceKey="reg"
                create={true}

                contextInRoute={true}
                contextFromRoute={local}
                ctx={{organizatorRegionalnoeOtdelenieID: local?.ID}}
                // context={{
                //     collection: regionalnoeOtdelenie,
                //     name: (item) => item.nazvanie,
                //     mix: (item) => {
                //         return {
                //             // organizatorFederatsiyaID: 1, // Организатор федерация
                //             // organizatorShkolaID: ID, // Организатор школа
                //             // organizatorMeropriyatiyaID: ID, // Организатор мероприятия
                //             organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
                //         }
                //     }
                // }}
            />}
        </PageLayout>
    );
}
